import { listRequest2Redux } from "lib-core"

const convertError = e => {
  if (e instanceof Error) {
    return {
      message: e.message,
      code: e.code,
      errors: e.errors
    }
  } else {
    return e
  }
}

const shouldPreserve = (action, preserve) => {
  if (action.payload && action.payload.opts) {
    if (
      action.payload.opts.preserve === true ||
      action.payload.opts.preserve === false
    ) {
      return action.payload.opts.preserve
    }
  }
  return preserve
}

const list = (name, opts, extra_reducers) => {
  if (typeof opts !== 'object') {
    opts = { preserve_on_reload: opts }
  }

  const LOAD_REQUEST = `load-${name}-request`
  const LOAD_SUCCESS = `load-${name}-success`
  const LOAD_FAILURE = `load-${name}-failure`
  const UPDATE_REQUEST = `update-${name}-request`
  const UPDATE_SUCCESS = `update-${name}-success`
  const UPDATE_FAILURE = `update-${name}-failure`
  return (state: any = {}, action: any = {}) => {
    let preserve = shouldPreserve(action, opts.preserve_on_reload)
    switch (action.type) {
      case LOAD_REQUEST:
        state = {
          ...state,
          map: preserve && state.map ? state.map : undefined,
          list: {
            loading: true,
            values: preserve && state.list ? state.list.values : []
          },
          extra: preserve && state.extra ? state.extra : undefined
        }
        break
      case LOAD_SUCCESS:
        const result = action.payload.result
        state = listRequest2Redux(result, state)
        break
      case LOAD_FAILURE:
        state = {
          ...state,
          list: {
            loading: false,
            error: convertError(action.payload.error)
          }
        }
        break
      case UPDATE_SUCCESS:
        state = {
          ...state,
          map: Object.assign({}, state.map, {
            [action.payload.result._id]: action.payload.result
          }),
          list: state.list,
          extra: state.extra
        }
        break
    }
    return extra_reducers ? extra_reducers(state, action) : state
  }
}

const one = (name, opts, extra_reducers) => {
  if (typeof opts !== 'object') {
    opts = { preserve_on_reload: opts }
  }
  const LOAD_REQUEST = `load-${name}-request`
  const LOAD_SUCCESS = `load-${name}-success`
  const LOAD_FAILURE = `load-${name}-failure`
  const UPSERT_REQUEST = `upsert-${name}-request`
  const UPSERT_SUCCESS = `upsert-${name}-success`
  const UPSERT_FAILURE = `upsert-${name}-failure`
  const UPDATE_REQUEST = `update-${name}-request`
  const UPDATE_SUCCESS = `update-${name}-success`
  const UPDATE_FAILURE = `update-${name}-failure`
  const INSERT_REQUEST = `insert-${name}-request`
  const INSERT_SUCCESS = `insert-${name}-success`
  const INSERT_FAILURE = `insert-${name}-failure`
  const DELETE_REQUEST = `delete-${name}-request`
  const DELETE_SUCCESS = `delete-${name}-success`
  const DELETE_FAILURE = `delete-${name}-failure`
  return (state = {}, action = {}) => {
    switch (action.type) {
      case LOAD_REQUEST:
        if (shouldPreserve(action, opts.preserve_on_reload)) {
          state = {
            ...state,
            loading: true,
            value: state.value
          }
        } else {
          state = {
            loading: true
          }
        }
        break
      case LOAD_SUCCESS:
        state = {
          ...state,
          loading: false,
          value: action.payload.result
        }
        break
      case LOAD_FAILURE:
        state = {

          loading: false,
          error: convertError(action.payload.error)
        }
        break
      case UPSERT_REQUEST:
      case INSERT_REQUEST:
      case UPDATE_REQUEST:
        state = {
          ...state,
          upserting: true,
          value: shouldPreserve(action, opts.preserve_on_update)
            ? state.value
            : undefined
        }
        break
      case UPSERT_SUCCESS:
      case INSERT_SUCCESS:
      case UPDATE_SUCCESS:
        state = {
          ...state,
          upserting: false,
          value: action.payload.result
        }
        break
      case UPSERT_FAILURE:
      case INSERT_FAILURE:
      case UPDATE_FAILURE:
        state = {
          ...state,
          upserting: false,
          upsertError: convertError(action.payload.error),
          value: shouldPreserve(action, opts.preserve_on_update)
            ? state.value
            : undefined
        }
        break
      case DELETE_REQUEST:
        state = {
          ...state,
          deleting: true,
          value: state.value
        }
        break
      case DELETE_SUCCESS:
        state = {
          ...state,
          deleting: false
        }
        break
      case DELETE_FAILURE:
        state = {
          ...state,
          deleting: false,
          deleteError: convertError(action.payload.error),
          value: state.value
        }
        break
    }
    return extra_reducers ? extra_reducers(state, action) : state
  }
}

export default {
  list,
  one
}
